import axios from "axios";
import MainService from "./MainService";

export default class GeneralLanguageService extends MainService {

    constructor() {
		super();
		this.url = `${this.apiUrl}/general-languages`;
	}

    list() {
        return axios.get(this.url);
    }

}



// WEBPACK FOOTER //
// ./src/service/GeneralLanguageService.js